import { CountResponse } from '@typings';

import { PaginatedResponse } from 'src/app/typings/PaginatedResponse';

import { Offer, OfferListItem } from '../interfaces/offersInterface';

export function offerTableFactory(
  response: PaginatedResponse<Offer>
): CountResponse<OfferListItem> {
  function formatReal(value: number) {
    return `R$ ${value.toFixed(2).replace('.', ',')}`;
  }

  return {
    rows: response.data.map(data => {
      const formattedOffer: OfferListItem = {
        id: data.id,
        name: data.name,
        fullPrice: formatReal(data.fullPrice),
        startDate: new Date(data.startDate).toLocaleDateString(),
        endDate: data.endDate
          ? new Date(data.endDate).toLocaleDateString()
          : undefined,
        active: data.active,
        acquisitionId: data.acquisitionId,
        seasonalityId: data.seasonalityId,
        status: data.status,
        typeId: data.typeId,
        replaceDefaultOffer: data.replaceDefaultOffer,
        label: data.label,
        isFallbackOffer: data.isFallbackOffer,
        flow: data.flow ?? null,
      };

      return formattedOffer;
    }),
    count: response.total,
  };
}
